export default __webpack_public_path__ + "static/media/IBimagePositiverunning1.0ee13321.png";